import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getClinicalEfficiencyOverview,
  type ClinicalEfficiencyOverviewResult,
} from '@services/api/dashboard/clinical-efficiency.api'

export function useClinicalEfficiencyOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<ClinicalEfficiencyOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getClinicalEfficiencyOverview, {
    enabled,
    queued,
  })
}
